// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1LLJv","top":"styles_top__34UGk","left":"styles_left__2L80J","description":"styles_description__1_sTK"};